import { render, staticRenderFns } from "./BeneficiaryOwner.vue?vue&type=template&id=832e2b9a&"
import script from "./BeneficiaryOwner.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports